import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const IncompleteDataTitleContainer = styled('div')`
  display: flex;
  margin-bottom: 14px;

  i:before {
    background-color: ${({ theme }) => theme.colors.danger.normal};
  }
`

export const IncompleteDataTitle = styled('p')`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.danger.normal};
  margin: 0 0 0 8px;
`

export const IncompleteDataText = styled.div`
  margin-bottom: 14px;
`

export const CustomIcon = styled(Icon)`
  align-self: center;
`
